var $fa02fe0d4c09a614$exports = {};
$fa02fe0d4c09a614$exports = {
    "Empty": `\u{41D}\u{435} \u{437}\u{430}\u{43F}\u{43E}\u{43B}\u{43D}\u{435}\u{43D}\u{43E}`
};


export {$fa02fe0d4c09a614$exports as default};
//# sourceMappingURL=ru-RU.mjs.map
